import type { ElementType, PropsWithChildren, ReactNode } from "react";

import type { PolymorphicProps } from "shared/types";

import { cn } from "shared/utils/cn";

type Props<E extends ElementType> = PolymorphicProps<
  E,
  {
    label?: ReactNode;
    className?: string;
    disabled?: boolean;
  }
>;

export const Field = <E extends ElementType>(
  props: PropsWithChildren<Props<E>>
) => {
  const {
    className,
    label,
    children,
    disabled,
    as = "div",
    ...restProps
  } = props;
  const Comp = as;
  return (
    <Comp
      className={cn(
        "border-dark-grey relative flex min-h-11.5 w-full flex-col items-center gap-y-2 rounded-xl border p-3 outline-hidden transition-colors",
        disabled && "pointer-events-none",
        className
      )}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </Comp>
  );
};
